window.onload = function() {
  const pathname = location.pathname;
  const img = document.querySelector("#headerContainer a  img");
  
  if (pathname != "/") {
    // 黒
    img.src = "//cdn.shopify.com/s/files/1/0262/5408/2129/files/the-terrusse-logo.png";  
  }
}

window.addEventListener('scroll', function () {
  const pathname = location.pathname;
  if (pathname != "/") {
    return false;
  }
  
  const scroll = window.scrollY;
  const img = document.querySelector("#headerContainer a  img");
  
  if (scroll >= 100) { // 100は任意の値に変えてください
    // 黒
    img.src = "//cdn.shopify.com/s/files/1/0262/5408/2129/files/the-terrusse-logo.png";
  } else {
    // 白
    img.src = "//cdn.shopify.com/s/files/1/0262/5408/2129/files/1200-LOGO-white.png";
  }
});
